import { render, staticRenderFns } from "./AinIndex.vue?vue&type=template&id=1dff51f5&scoped=true"
import script from "./AinIndex.vue?vue&type=script&lang=js"
export * from "./AinIndex.vue?vue&type=script&lang=js"
import style0 from "./AinIndex.vue?vue&type=style&index=0&id=1dff51f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dff51f5",
  null
  
)

export default component.exports